module.exports = __webpack_public_path__ + "img/hr-filter-inserter-platform.2c7c70e6.png";